import { memo } from "react"

const BaseCalloutIcon = memo(({
  className,
  iconClass,
  ...props
}) => {
  return (
    <i
      className={[iconClass, className].filter(Boolean).join(" ")}
      aria-hidden="true"
      {...props}
    />
  );
})

export const CalloutInfoIcon = memo((props) => (
  <BaseCalloutIcon
    iconClass="far fa-circle-info"
    {...props} />
))

export const CalloutSuccessIcon = memo((props) => (
  <BaseCalloutIcon
    iconClass="far fa-circle-check"
    {...props} />
))

export const CalloutWarningIcon = memo((props) => (
  <BaseCalloutIcon
    iconClass="far fa-triangle-exclamation"
    {...props} />
))

export const CalloutDangerIcon = memo((props) => (
  <BaseCalloutIcon
    iconClass="far fa-circle-exclamation"
    {...props} />
))

export function getCalloutVariantIcon(variant) {
  switch (variant) {
    case "success":
      return CalloutSuccessIcon
    case "warning":
      return CalloutWarningIcon
    case "danger":
      return CalloutDangerIcon
    case "info":
    default:
      return CalloutInfoIcon
  }
}

export const CalloutIcon = CalloutInfoIcon

CalloutIcon.displayName = "CalloutIcon"
